module.exports = __webpack_public_path__ + "0d7af9e83f507eb4ba7ddfddb1c782b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/savvas-logo.jpg
// module id = 1619
// module chunks = 0